export var AvailableToolbarToolsEnum;
(function (AvailableToolbarToolsEnum) {
    AvailableToolbarToolsEnum["TEXT_SELECTOR"] = "TEXT_SELECTOR";
    AvailableToolbarToolsEnum["SIMPLE_TOOLS"] = "SIMPLE_TOOLS";
    AvailableToolbarToolsEnum["ALIGNMENT_SELECTOR"] = "ALIGNMENT_SELECTOR";
    AvailableToolbarToolsEnum["HIGHLIGHTER_VIEW"] = "HIGHLIGHTER_VIEW";
    AvailableToolbarToolsEnum["DOWNLOADING"] = "DOWNLOADING";
})(AvailableToolbarToolsEnum || (AvailableToolbarToolsEnum = {}));
